import { addingDynamicPagesPanel } from '@wix/wix-data-client-common/dist/esm/bi/panelDataForBi'

export const defaultPanelBiParams = {
  panel_name: addingDynamicPagesPanel.panelName,
  is_first_data_modal: false,
}
